import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <div className="max-w-3xl mx-auto mt-12 mb-8 px-4" data-id="element-168">
      <div className="bg-[#F4E8D8] border-2 border-[#8B4513] rounded-lg p-6 md:p-8 flex flex-col md:flex-row items-center gap-6 shadow-md relative overflow-hidden" data-id="element-169">
        {/* Decorative corner */}
        <div className="absolute top-0 right-0 w-16 h-16 bg-[#7C2D2D] opacity-10 transform rotate-45 translate-x-8 -translate-y-8" data-id="element-170"></div>

        <div className="flex-shrink-0 bg-[#FFF8E7] p-4 rounded-full border-2 border-[#7C2D2D]" data-id="element-171">
          <ShieldCheck className="w-12 h-12 text-[#7C2D2D]" data-id="element-172" />
        </div>

        <div className="text-center md:text-left" data-id="element-173">
          <h3 className="font-serif font-bold text-2xl text-[#2D241E] mb-3" data-id="element-174">
            Garantía de 7 Días
          </h3>
          <p className="font-sans text-[#5D4037] leading-relaxed" data-id="element-175">
            Si tenés algún inconveniente con tu compra, contactanos dentro de
            los 7 días y te ayudamos a resolverlo o te devolvemos el{' '}
            <span className="font-bold text-[#7C2D2D]" data-id="element-176">100% de tu dinero</span>.
            Comprá con total tranquilidad.
          </p>
        </div>
      </div>
    </div>;
}